// internal
import { TypeAssert } from '@creejs/commons-lang'
// owned
// eslint-disable-next-line no-unused-vars
import Logger from '../logger.js'
// eslint-disable-next-line no-unused-vars
import { Level, value2Name } from '../log-level.js'
import LogFactory from '../log-factory.js'

import Log4jsLogger from './log4js-logger.js'
import DefaultConfig from './log4js-6x-config.js'

const { assertString } = TypeAssert

/**
 * Use log4js as the logging provider.
 */
export default class Log4jsFactory extends LogFactory {
  /**
   * the log4js module instance.
   * @returns {{}} The log4js module instance.
   */
  get log4js () {
    return this._libraryModule
  }

  get setting () {
    if (this._setting == null) {
      this._setting = cloneDefaultConfig()
    }
    return this._setting
  }

  /**
   * Initializes the log4js provider by configuring it with the provided settings.
   * @override
   */
  init () {
    // @ts-ignore
    this.log4js.configure(this.setting)
  }

  /**
   * Update factory's Log Level
   * 1. Only Provider knows how to update
   * @param {number} level - The log level to set, see {@link LogLevel.Level}
   * @returns {void}
   * @throws {Error} Throws an error as this method is Not Impled Yet.
   * @abstract
   */
  setLevel (level) {
    let levelName = value2Name(level)
    if (levelName == null) {
      throw new Error(`Invalid log level: ${level}`)
    }
    levelName = levelName.toLowerCase()
    let updated = false
    // @ts-ignore
    const { categories } = this.setting
    for (const categoryKey in categories) {
      const category = categories[categoryKey]
      const { level: categoryLevel } = category
      if (categoryLevel !== levelName) {
        category.level = levelName.toLowerCase()
        updated = true
      }
    }
    // init log4js again
    updated && this.init()
  }

  /**
   * Creates a new logger instance with the specified name and log level.
   * @param {string} loggerName - The name of the logger to create.
   * @returns {Logger} A new logger instance configured with the given name and level.
   * @override
   */
  createLogger (loggerName) {
    assertString(loggerName)
    // @ts-ignore
    const nativeLogger = this.log4js.getLogger(loggerName)
    const logger = new Log4jsLogger(loggerName, nativeLogger)
    return logger
  }
}

function cloneDefaultConfig () {
  return JSON.parse(JSON.stringify(DefaultConfig))
}
